export default {
  zh: {
    domTitle: '周星',
    rules: '规则',
    rules_introduction_1: '1.仅在赠送指定礼物时才计算数值。',
    rules_introduction_2: '2.各榜单计算时间为本周一00:00至周日23:59（GMT+3)。',
    rules_introduction_3: '3、每个榜单都有排名，每个排名的TOP1、TOP2、TOP3将获得奖励。',
    days: '天',
    hours: '小时',
    minutes: '分钟',
    seconds: '秒',
    wealth: '财富',
    charm: '魅力',
    reward: '奖励',
    this_week: '这周',
    last_week: '下周',
    top1: 'TOP1',
    top2: 'TOP2',
    top3: 'TOP3',
    banner_7days: '横幅*7天',
    badge_7days: '勋章*7天',
    vip4_7days: 'VIP4*7天',
    headwear_7days: '头饰*7天',
    vehicle_7days: '座驾*7天',
    vip3_7days: 'VIP3*7天',
    vip3_5days: 'VIP3*5天',
    '7_days': '7天',
    '5_days': '5 天',
    '3_days': '3 天',
    weekly_star_button_introduction_1: '本次活动解释权归 Yayya 所有',
    weekly_star_button_introduction_2: '本活动与APPLE无关',
  },
  en: {
    domTitle: 'Weekly Star',
    rules: 'Rules',
    rules_introduction_1: '1.The quantity is counted only when specified gifts are given.',
    rules_introduction_2: '2.Each list will be calculated from 00:00 this Monday to this Sunday 23:59 (GMT+3).',
    rules_introduction_3: '3. Each list has a ranking,and the TOP1,TOP2,TOP3 of each ranking will be rewarded.  ',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    wealth: 'Wealth',
    charm: 'Charm',
    reward: 'Reward',
    this_week: 'This week',
    last_week: 'Last week',
    top1: 'TOP1',
    top2: 'TOP2',
    top3: 'TOP3',
    banner_7days: 'BANNER*7 days',
    badge_7days: 'Badge*7 days',
    vip4_7days: 'VIP4*7 days',
    headwear_7days: 'Headwear*7 days',
    vehicle_7days: 'Vehicle*7 days',
    vip3_7days: 'VIP3*7 days',
    vip3_5days: 'VIP3*5 days',
    '7_days': '7_days',
    '5_days': '5 days',
    '3_days': '3 days',
    weekly_star_button_introduction_1: 'The final interpretation right of this activity belongs to Yayya',
    weekly_star_button_introduction_2: 'This activity has nothing to do with APPLE ',
  },
  ar: {
    domTitle: 'النجم الاسبوعي',
    rules: 'القواعد',
    rules_introduction_1: '1. يتم احتساب القيمة فقط عند إرسال الهدية المحددة.',
    rules_introduction_2: '2. وقت الحساب لكل ترتيب هو من الساعة 00:00 يوم الاثنين إلى الساعة 23:59 يوم الأحد (GMT+3).',
    rules_introduction_3: '3. كل قائمة لها ترتيب ، وسيتلقى TOP1 وTOP2 وTOP3 في كل ترتيب مكافآت.',
    days: 'يوم',
    hours: 'ساعة',
    minutes: 'دقيقة',
    seconds: 'ثوان',
    wealth: 'ثروة',
    charm: 'كاريزما',
    reward: 'مكافآت',
    this_week: 'الأسبوع الجاري',
    last_week: 'الأسبوع الماضي',
    top1: 'TOP1',
    top2: 'TOP2',
    top3: 'TOP3',
    banner_7days: 'البنر * 7 أيام',
    badge_7days: 'الميدالية *7 أيام',
    vip4_7days: '7 أيام * VIP4 ',
    headwear_7days: 'الاطار* 7 أيام',
    vehicle_7days: 'الدخولية * 7 أيام',
    vip3_7days: '7 أيام * VIP3',
    vip3_5days: '5 أيام * VIP3',
    '7_days': '7 أيام',
    '5_days': '5 أيام ',
    '3_days': '3 أيام',
    weekly_star_button_introduction_1: 'الحق النهائي في تفسير هذا النشاط يعود إلى Yayya',
    weekly_star_button_introduction_2: 'هذا النشاط ليس له علاقة بشركة APPLE',
  },
  tr: {
    domTitle: 'Haftalık Yıldız',
    rules: 'Kural',
    rules_introduction_1: '1. Miktar yalnızca belirtilen hediyeler verildiğinde sayılır.',
    rules_introduction_2: "2.Her liste Pazartesi saat 00:00'dan Pazar saat 23:59'a (Tr Saatine) kadar hesaplanacaktır.",
    rules_introduction_3:
      "3. Her listenin bir sıralaması vardır ve her sıralamanın İLK1,İLK2,İLK3'ü ödüllendirilecektir.",
    days: 'Gün',
    hours: 'Saat',
    minutes: 'Dakika',
    seconds: 'Saniye',
    wealth: 'Zenginlik',
    charm: 'Cazibe',
    reward: 'Ödül',
    this_week: 'Bu Hafta',
    last_week: 'Geçen Hafta',
    top1: 'İLK1',
    top2: 'İLK2',
    top3: 'İLK3',
    banner_7days: 'Banner*7 Gün',
    badge_7days: 'Rozet*7 Gün',
    vip4_7days: 'VIP4*7 Gün',
    headwear_7days: 'Çerçeve*7 Gün',
    vehicle_7days: 'Araç*7 Gün',
    vip3_7days: 'VIP3*7 Gün',
    vip3_5days: 'VIP3*5 Gün',
    '7_days': '7 Gün',
    '5_days': '5 Gün',
    '3_days': '3 Gün',
    weekly_star_button_introduction_1: "Bu etkinliğin son yorumlama hakkı Yayya'e aittir.",
    weekly_star_button_introduction_2: 'Bu etkinliğin APPLE ile hiçbir ilgisi yoktur',
  },
  pt: {
    domTitle: 'Estrela da Semana',
    rules: 'Regras',
    rules_introduction_1: '1. A quantidade é contada somente quando presentes específicos são dados.',
    rules_introduction_2:
      '2. Cada lista será calculada de 00:00 desta segunda-feira até este domingo às 23:59 (GMT+3).',
    rules_introduction_3: '3. Cada lista tem um ranking, e os TOP1, TOP2, TOP3 de cada ranking serão recompensados.',
    days: 'Dias',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
    wealth: 'Riqueza',
    charm: 'Charme',
    reward: 'Recompensa',
    this_week: 'Esta semana',
    last_week: 'Semana passada',
    top1: 'TOP1',
    top2: 'TOP2',
    top3: 'TOP3',
    banner_7days: 'BANNER*7 dias',
    badge_7days: 'Distintivo*7 dias',
    vip4_7days: 'VIP4*7 dias',
    headwear_7days: 'Acessório*7 dias',
    vehicle_7days: 'Veículo*7 dias',
    vip3_7days: 'VIP3*7 dias',
    vip3_5days: 'VIP3*5 dias',
    '7_days': '7 dias',
    '5_days': '5 dias',
    '3_days': '3 dias',
    weekly_star_button_introduction_1: 'O direito de interpretação final desta atividade pertence à Yayya',
    weekly_star_button_introduction_2: 'Esta atividade não tem relação com a APPLE',
  },
  id: {
    domTitle: 'Bintang Mingguan',
    rules: 'Aturan',
    rules_introduction_1: '1. Jumlah hanya dihitung ketika hadiah yang ditentukan diberikan.',
    rules_introduction_2:
      '2. Setiap daftar akan dihitung dari pukul 00:00 Senin ini hingga Minggu ini pukul 23:59 (GMT+3).',
    rules_introduction_3:
      '3. Setiap daftar memiliki peringkat, dan TOP1, TOP2, TOP3 dari setiap peringkat akan diberikan hadiah.',
    days: 'Hari',
    hours: 'Jam',
    minutes: 'Menit',
    seconds: 'Detik',
    wealth: 'Kekayaan',
    charm: 'Pesona',
    reward: 'Hadiah',
    this_week: 'Minggu ini',
    last_week: 'Minggu lalu',
    top1: 'TOP1',
    top2: 'TOP2',
    top3: 'TOP3',
    banner_7days: 'BANNER*7 hari',
    badge_7days: 'Lencana*7 hari',
    vip4_7days: 'VIP4*7 hari',
    headwear_7days: 'Penutup Kepala*7 hari',
    vehicle_7days: 'Kendaraan*7 hari',
    vip3_7days: 'VIP3*7 hari',
    vip3_5days: 'VIP3*5 hari',
    '7_days': '7 hari',
    '5_days': '5 hari',
    '3_days': '3 hari',
    weekly_star_button_introduction_1: 'Hak penafsiran akhir dari acara ini milik Yayya',
    weekly_star_button_introduction_2: 'Acara ini tidak ada kaitannya dengan APPLE',
  },
  uz: {
    domTitle: 'Haftalik Yulduz',
    rules: 'Qoidalar',
    rules_introduction_1: "1.Ballar faqat ko'rsatilgan sovg'alarni topshirishda hisobga olinadi.",
    rules_introduction_2:
      "2.Har bir ro'yxat shu dushanba kuni soat 00:00 dan yakshanba kuni soat 23:59 gacha (GMT+3) hisoblanadi.",
    rules_introduction_3:
      "3. Har bir ro'yxat o'z reytingiga ega va har bir reytingda top 1, top 2, top 3 mukofotlanadi.",
    days: 'Kunlar',
    hours: 'Soatlar',
    minutes: 'Daqiqalar',
    seconds: 'Soniyalar',
    wealth: 'Boylik',
    charm: 'Joziba',
    reward: 'Mukofot',
    this_week: 'Bu hafta',
    last_week: "O'tgan hafta",
    top1: 'TOP1',
    top2: 'TOP2',
    top3: 'TOP3',
    banner_7days: 'BANNER*7 kun',
    badge_7days: 'Nishon*7 kun',
    vip4_7days: 'VIP4*7 kun',
    headwear_7days: 'Bosh kiyim*7 kun',
    vehicle_7days: 'Haydash* 7 kun',
    vip3_7days: 'VIP3*7 kun',
    vip3_5days: 'VIP3*5 kun',
    '7_days': '7 kun',
    '5_days': '5 kun',
    '3_days': '3 kun',
    weekly_star_button_introduction_1: 'Ushbu harakatni talqin qilishning yakuniy huquqi Yayyaga tegishli',
    weekly_star_button_introduction_2: "Ushbu tadbir APPLE bilan hech qanday aloqasi yo'q",
  },
  ru: {
    domTitle: 'Еженедельная звезда',
    rules: 'Правила',
    rules_introduction_1: '1.Очки учитываются только при вручении указанных подарков.',
    rules_introduction_2:
      '2.Каждый список будет рассчитан с 00:00 этого понедельника по 23:59 этого воскресенья (GMT+3).',
    rules_introduction_3:
      '3. Каждый список имеет свой рейтинг, и ТОП-1, ТОП-2, ТОП-3 в каждом рейтинге будут вознаграждены.',
    days: 'Дни',
    hours: 'Часы',
    minutes: 'Минуты',
    seconds: 'Секунды',
    wealth: 'Богатство',
    charm: 'Очарование',
    reward: 'Награда',
    this_week: 'На этой неделе',
    last_week: 'На прошлой неделе',
    top1: 'ТОП-1',
    top2: 'ТОП-2',
    top3: 'ТОП-3',
    banner_7days: 'БАННЕР*7 дней',
    badge_7days: 'Бейдж*7 дней',
    vip4_7days: 'VIP4*7 дней',
    headwear_7days: 'Головной убор*7 дней',
    vehicle_7days: 'Драйв*7 дней',
    vip3_7days: 'VIP3*7 дней',
    vip3_5days: 'VIP3*5 дней',
    '7_days': '7 дней',
    '5_days': '5 дней',
    '3_days': '3 дня',
    weekly_star_button_introduction_1: 'Окончательное право на интерпретацию этого действия принадлежит Yayya',
    weekly_star_button_introduction_2: 'Это мероприятие не имеет никакого отношения к APPLE',
  },
  fa: {
    domTitle: 'ستاره هفتگی',
    rules: 'قوانین',
    rules_introduction_1: '1. تعداد فقط زمانی حساب می‌شود که هدایا مشخص شده داده شوند.',
    rules_introduction_2: '2. هر لیست از ساعت 00:00 دوشنبه این هفته تا 23:59 یکشنبه این هفته (GMT+3) محاسبه خواهد شد.',
    rules_introduction_3: '3. هر لیست دارای رتبه بندی است و TOP1، TOP2، TOP3 هر رتبه بندی پاداش خواهند گرفت.',
    days: 'روزها',
    hours: 'ساعت‌ها',
    minutes: 'دقایق',
    seconds: 'ثانیه‌ها',
    wealth: 'ثروت',
    charm: 'جاذبه',
    reward: 'پاداش',
    this_week: 'این هفته',
    last_week: 'هفته گذشته',
    top1: 'TOP1',
    top2: 'TOP2',
    top3: 'TOP3',
    banner_7days: 'بنر*7 روز',
    badge_7days: 'نشان*7 روز',
    vip4_7days: 'VIP4*7 روز',
    headwear_7days: 'پوشش سر*7 روز',
    vehicle_7days: 'وسایل نقلیه*7 روز',
    vip3_7days: 'VIP3*7 روز',
    vip3_5days: 'VIP3*5 روز',
    '7_days': '7 روز',
    '5_days': '5 روز',
    '3_days': '3 روز',
    weekly_star_button_introduction_1: 'حق تفسیر نهایی این فعالیت متعلق به Yayya است',
    weekly_star_button_introduction_2: 'این فعالیت هیچ ارتباطی با APPLE ندارد',
  },
  ur: {
    domTitle: 'ہفتہ وار اسٹار',
    rules: 'قواعد',
    rules_introduction_1: '1.مخصوص تحائف دینے پر ہی مقدار شمار کی جائے گی۔',
    rules_introduction_2: '2.ہر فہرست کا حساب اس ہفتے کے پیر 00:00 سے اتوار 23:59 (GMT+3) تک لگایا جائے گا۔',
    rules_introduction_3: '3. ہر فہرست کی ایک درجہ بندی ہوگی، اور ہر درجہ بندی کے TOP1،TOP2،TOP3 کو انعام دیا جائے گا۔',
    days: 'دن',
    hours: 'گھنٹے',
    minutes: 'منٹ',
    seconds: 'سیکنڈ',
    wealth: 'دولت',
    charm: 'دلکشی',
    reward: 'انعام',
    this_week: 'اس ہفتے',
    last_week: 'گزشتہ ہفتے',
    top1: 'ٹاپ 1',
    top2: 'ٹاپ 2',
    top3: 'ٹاپ 3',
    banner_7days: 'بینر*7 دن',
    badge_7days: 'بیج*7 دن',
    vip4_7days: 'VIP4*7 دن',
    headwear_7days: 'ہیڈ ویئر*7 دن',
    vehicle_7days: 'گاڑی*7 دن',
    vip3_7days: 'VIP3*7 دن',
    vip3_5days: 'VIP3*5 دن',
    '7_days': '7 دن',
    '5_days': '5 دن',
    '3_days': '3 دن',
    weekly_star_button_introduction_1: 'اس سرگرمی کی حتمی تشریح کا حق Yayya کے پاس ہے',
    weekly_star_button_introduction_2: 'اس سرگرمی کا APPLE سے کوئی تعلق نہیں ہے',
  },
}



// WEBPACK FOOTER //
// src/pages/activity/newWeeklyStar/lang.js